import Alpine from 'alpinejs';
import './htmx';
import { startStoreServerTimestampUpdate } from "@core/js/server-time";
import { startSSE } from "@core/js/sse";

import Lot from "@core/js/widgets/lot";

// Register Alpine components
Alpine.data('Lot', Lot);

startStoreServerTimestampUpdate();
startSSE();

window.Alpine = Alpine;
Alpine.start();